export const PLACE_HOLDER = '-- Sélectionner --';
